import { fontSize as getFontSize, gridSize as getGridSize } from '@atlaskit/theme/constants';
import { css } from '@emotion/core';

import {
  alignItemsCenter,
  cursorPointer,
  flex,
  SPACE_COMPACT,
  SPACE_MINIMUM,
  extendWidth,
  zeroWidth,
} from '@/styles';

const fontSize = getFontSize();
const gridSize = getGridSize();
const minRows = 1;
const textAreaLineHeightFactor = 2.5;

export const readViewContainer = css({
  lineHeight: `${(gridSize * textAreaLineHeightFactor) / fontSize}`,
  minHeight: `${gridSize * textAreaLineHeightFactor * minRows}px`,
  padding: `${gridSize - 2}px 0`,
  wordBreak: 'break-word',
});

export const annotationEdit = [extendWidth];
export const annotationView = [zeroWidth];

export const editIcon = [
  cursorPointer,
  css`
    margin: ${SPACE_COMPACT}px ${SPACE_MINIMUM}px 0 ${SPACE_COMPACT}px;
  `,
];

export const annotationColumn = [
  flex,
  alignItemsCenter,
  css`
    margin-bottom: ${SPACE_COMPACT}px;
    textarea {
      ${extendWidth}
      min-width: 400px;
    }
  `,
];

export const annotationErrorMessage = [
  flex,
  alignItemsCenter,
  css`
    span {
      margin-right: ${SPACE_MINIMUM}px;
    }
  `,
];
